export const autoConsentBanner = true
      
export const cookieBotId = "5b5d2d8d-942c-48e7-84e5-b954ea4c748f"
      